import script from "./Purches.vue?vue&type=script&setup=true&lang=js"
export * from "./Purches.vue?vue&type=script&setup=true&lang=js"

import "./Purches.vue?vue&type=style&index=0&id=2a1b2ba7&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a1b2ba7"]])

export default __exports__